import { DateTime } from '@utils';
import { TableWrapper } from '@components';
import PrimarySecondary from '@common/ui/PrimarySecondary';
import {
  Button,
  ButtonGroup,
  Stack,
  Table as MuiTable,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { useListAuditEvents } from '@api/gql-queries/use-list-audit-events';

export default function AuditEventsTable() {
  const {
    data,
    isLoading,
    hasNextPage,
    fetchNextPage,
    hasPreviousPage,
    fetchPreviousPage,
    isFetchingNextPage,
    isFetchingPreviousPage,
  } = useListAuditEvents();

  const items = data?.pages.flatMap((page) => page.data) || [];

  return (
    <Stack direction="column" justifyContent="center" alignItems="stretch" spacing={2}>
      <TableWrapper loading={isLoading}>
        <MuiTable>
          <TableHead>
            <TableRow>
              <TableCell>User</TableCell>
              <TableCell>Time</TableCell>
              <TableCell>Integration</TableCell>
              <TableCell>Event Type</TableCell>
              <TableCell>Action</TableCell>
              <TableCell>Target</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map(({ node }) => (
              <TableRow key={node.id}>
                <TableCell component="td">
                  <PrimarySecondary
                    primary={`${node.user.firstName} ${node.user.lastName}`}
                    secondary={node.user.email}
                  />
                </TableCell>
                <TableCell component="td">
                  {DateTime.fromUnixWithFormat(Number(node.timestamp), 'DD/MM/YYYY HH:mm:ss')}
                </TableCell>
                <TableCell component="td">
                  <PrimarySecondary primary={node.integration.name} icon={node.integration.icons.svg} />
                </TableCell>
                <TableCell component="td">{node.eventType}</TableCell>
                <TableCell component="td">{node.action}</TableCell>
                <TableCell component="td">{node.target}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </MuiTable>
      </TableWrapper>
      <ButtonGroup sx={{ alignSelf: 'end' }}>
        <Button onClick={() => fetchPreviousPage()} disabled={!hasPreviousPage || isFetchingPreviousPage}>
          Previous
        </Button>
        <Button onClick={() => fetchNextPage()} disabled={!hasNextPage || isFetchingNextPage}>
          Next
        </Button>
      </ButtonGroup>
    </Stack>
  );
}
